import { render, staticRenderFns } from "./Tiles.vue?vue&type=template&id=201967b0&scoped=true"
import script from "./Tiles.vue?vue&type=script&lang=ts"
export * from "./Tiles.vue?vue&type=script&lang=ts"
import style0 from "./Tiles.vue?vue&type=style&index=0&id=201967b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201967b0",
  null
  
)

export default component.exports